// PropTypes & React HOOKS:
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'

// COMPONENTS:
import MailSplitTable from 'components/ui/Table/MailSplitTable'
import ColumnFilter from 'components/ui/Table/ColumnFilter'

export default function MailSplitCompGrid({
  items,
  handleClick,
  handleSendMail,
  handleLoadingModal,
  handleDelete,
  isLoading
}) {
  const [getTableData, setTableData] = useState([])

  // Columnas:
  const columns = [
    {
      Header: 'Nº Cliente',
      accessor: 'MailSplit_IdSingle',
      Filter: ColumnFilter
    },
    {
      Header: 'Cliente',
      accessor: 'MailSplit_NameSingle',
      Filter: ColumnFilter
    },
    {
      Header: 'Correo',
      accessor: 'MailSplit_EmailSingle',
      Filter: ColumnFilter
    },
    {
      Header: 'Enviado',
      accessor: 'MailSplit_IsSent',
      Filter: ColumnFilter
    },
    {
      Header: 'Archivo',
      accessor: 'MailSplit_FilePath',
      Filter: ColumnFilter
    },
    {
      Header: 'Enviar',
      Filter: ColumnFilter
    },
    {
      Header: 'Eliminar',
      Filter: ColumnFilter
    }
  ]

  // Adaptar datos para la tabla:
  useEffect(() => {
    if (items) {
      const itemsData = []

      items.forEach((item) => {
        itemsData.push({
          MailSplit_Id: item.Id,
          MailSplit_FileName: item.FileName,
          MailSplit_FilePath: item.FilePath,
          MailSplit_IsSent: item.IsSent,
          MailSplit_IdSingle: item.IdSingle,
          MailSplit_NameSingle: item.NameSingle,
          MailSplit_EmailSingle: item.EmailSingle,
          MailSplit_IdMail: item.IdMail,
          MailSplit_DateMail: item.DateMail,
          MailSplit_SubjectMail: item.SubjectMail,
          MailSplit_MessageMail: item.MessageMail,
          MailSplit_CommentMail: null
        })
      })
      setTableData(itemsData)
    }
  }, [items])

  return (
    <div className="overflow-x-auto">
      <div className="align-middle inline-block min-w-full">
        <div className="shadow overflow-hidden border-b border-gray-200">
          {getTableData.length > 0 && (
            <MailSplitTable
              data={getTableData}
              columns={columns}
              handleClick={handleClick}
              handleSendMail={handleSendMail}
              handleLoadingModal={handleLoadingModal}
              handleDelete={handleDelete}
              isLoading={isLoading}
            />
          )}
        </div>
      </div>
    </div>
  )
}

MailSplitCompGrid.propTypes = {
  items: PropTypes.array.isRequired,
  handleClick: PropTypes.func,
  handleSendMail: PropTypes.func,
  handleLoadingModal: PropTypes.func,
  handleDelete: PropTypes.func,
  isLoading: PropTypes.bool
}
